/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_SettingsInputs */

const en_community_settings = /** @type {(inputs: Community_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community Settings`)
};

const es_community_settings = /** @type {(inputs: Community_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de la Comunidad`)
};

const fr_community_settings = /** @type {(inputs: Community_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de la communauté`)
};

const de_community_settings = /** @type {(inputs: Community_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Einstellungen`)
};

const id_community_settings = /** @type {(inputs: Community_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan Komunitas`)
};

/** @type {(inputs: Community_SettingsInputs) => LocalizedString} */
const ja_community_settings = en_community_settings;

/** @type {(inputs: Community_SettingsInputs) => LocalizedString} */
const zh_community_settings = en_community_settings;

/** @type {(inputs: Community_SettingsInputs) => LocalizedString} */
const ar_community_settings = en_community_settings;

/** @type {(inputs: Community_SettingsInputs) => LocalizedString} */
const it_community_settings = en_community_settings;

/** @type {(inputs: Community_SettingsInputs) => LocalizedString} */
const ru_community_settings = en_community_settings;

/** @type {(inputs: Community_SettingsInputs) => LocalizedString} */
const pt_community_settings = en_community_settings;

/** @type {(inputs: Community_SettingsInputs) => LocalizedString} */
const ko_community_settings = en_community_settings;

/**
* | output |
* | --- |
* | "Community Settings" |
*
* @param {Community_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_settings = /** @type {((inputs?: Community_SettingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_SettingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_settings(inputs)
	if (locale === "es") return es_community_settings(inputs)
	if (locale === "fr") return fr_community_settings(inputs)
	if (locale === "de") return de_community_settings(inputs)
	if (locale === "ja") return ja_community_settings(inputs)
	if (locale === "zh") return zh_community_settings(inputs)
	if (locale === "ar") return ar_community_settings(inputs)
	if (locale === "id") return id_community_settings(inputs)
	if (locale === "it") return it_community_settings(inputs)
	if (locale === "ru") return ru_community_settings(inputs)
	if (locale === "pt") return pt_community_settings(inputs)
	return ko_community_settings(inputs)
});